<template>
  <v-container
    class="fill-height"
    fluid
    v-if="!isAuth"
  >

    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="teal"
            dark
            flat
          >
            <v-toolbar-title>Форма входа </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>

            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                label="Логин"
                name="login"
                prepend-icon="mdi-account"
                type="text"
                v-model="login"
              ></v-text-field>

              <v-text-field
                id="password"
                label="Пароль"
                name="password"
                prepend-icon="mdi-lock"
                type="password"
                v-model="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              dark
              color="teal"
              @click.prevent="signup"
            >Вход</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      login: null,
      password: null
    };
  },
  computed: {
    isAuth() {
      return this.$store.getters.getAuth;
    }
  },
  watch: {
    isAuth(val) {
      if (val === true) {
        this.$router.push("/");
      }
    }
  },
  methods: {
    signup() {
      this.$store.dispatch("SIGNUP", {
        login: this.login,
        password: this.password
      });
    }
  }
};
</script>
